import React from 'react';

const PhotoCard = ({ title, image, onClick }) => {
  return (
    <div className="photo-card" onClick={onClick} style={{ cursor: 'pointer' }}>
      <div className="photo-thumbnail">
        <img 
          src={image} 
          alt={title}
          loading="lazy"
          decoding="async"
        />
        <div className="photo-hover-overlay">
          <span className="photo-title">{title}</span>
        </div>
      </div>
    </div>
  );
};

export default React.memo(PhotoCard);